import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const allCategories = [{
  id: 'trending',
  label: 'All Designers',
  description: 'Trending designers first, followed by all other designers'
}];

// Only show the one category that encompasses both trending and all profiles
const categories = [allCategories[0]];

const CategoryTabs = () => {
  const [searchParams] = useSearchParams();
  const [activeCategory, setActiveCategory] = useState('trending'); // Default to trending
  const navigate = useNavigate();
  
  useEffect(() => {
    const categoryParam = searchParams.get('category') || 'trending';
    setActiveCategory(categoryParam);
  }, [searchParams]);
  
  const handleCategoryChange = (value: string) => {
    setActiveCategory(value);

    // Create new URL params, preserve existing filters but reset pagination
    const newParams = new URLSearchParams(searchParams);
    newParams.set('category', value);
    newParams.delete('page'); // Reset to page 1 when changing categories

    navigate(`/?${newParams.toString()}`, {
      replace: true
    });
  };

  // Hide this component since we're using the new tab system in Hero
  return null;
};

export default CategoryTabs;